const MissingPage = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '5rem',
      }}
    >
      ERROR 404
    </div>
  );
};

export default MissingPage;
